import React, { useRef, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import "../../Assets/Styles/pages/uploadImage.scss";
import { CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import CancelButton from "../Cancel_button/Cancel_button";
import ImageType from "../Cards/imageType";
import ImageDimensions from "../Cards/imageDimension";
import ImageQuality from "../Cards/imageQuality";
import { setCreate } from "../../Redux/DownloadSlice/downloadSlice";
import { useEffect } from "react";
const ProceedTemplate = ({
  open,
  setOpen,
  setLoaderParent,
  setOpenProgress,
}) => {
  const [loader, setLoader] = useState(false);
  const [landscape, setLandscape] = useState(false);
  const [image, setImage] = useState(null);

  const { t } = useTranslation();

  const modalRef = useRef();

  const downloadState = useSelector((state) => state["downloadSlice"]);

  const dispatch = useDispatch();

  const setDownload = () => {
    setOpenProgress(true);
  };

  useEffect(() => {
    setLoader(downloadState.Create);
  }, [downloadState.Create]);

  useEffect(() => {
    const effectFunc = async () => {
      if (downloadState.Image) {
        const image = new window.Image();
        image.src = downloadState.Image;
        image.onload = () => {
          const imageHeight = image.height;
          const imageWidth = image.width;

          if (imageHeight < imageWidth || imageHeight === imageWidth)
            setLandscape(true);
          else setLandscape(false);
          // setImage(img)
        };
      }
    };
    effectFunc();
  }, [downloadState.Image]);

  useEffect(() => {
    if (open) {
      setLoaderParent(false);
      dispatch(setCreate(-1));
    }
  }, [open]);
  useEffect(() => {
    setImage(downloadState.Image);
  }, [downloadState.Image]);

  const handleClose = () => {
    setOpen(false);
    dispatch(setCreate(0));
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        handleClose();
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row ref={modalRef} className="model  m-0">
          <CancelButton close={() => handleClose()} />
          <Col className="mt-4 pt-1">
            <Row>
              <Row className="d-flex justify-content-center RalewayBold text_22 black_0C0C0C">
                {t("DownloadImage.Title")}
              </Row>
              <Row className="Aktiv text_17 d-flex justify-content-center">
                {t("DownloadImage.Discription")}
              </Row>
            </Row>
            <Row>
              <Col className="border-top my-3 mx-4">
                <Row>
                  <Col>
                    <Col className="h-100 d-flex flex-column align-items-center justify-content-center">
                      <img
                        alt="proceed"
                        className={`${landscape ? "w-100" : "w-75"} mt-4`}
                        src={image}
                      />
                    </Col>
                  </Col>
                  <Col>
                    <Col className="mt-4">
                      <ImageType />
                    </Col>
                    <Col className="mt-3">
                      <ImageDimensions />
                    </Col>
                    <Col className="mt-3">
                      <ImageQuality />
                    </Col>
                  </Col>
                </Row>
                <Col className=" CamptonMedium h-25 text_15 mt-4">
                  {/* <Row>
                                        <Row> {t("DownloadImage.Dimension")} {dimens}</Row>
                                        <Row> {t("DownloadImage.ImageSize")} {size}</Row>
                                    </Row> */}
                  <Row className="d-flex justify-content-center align-items-center">
                    <button
                      className="continue_button text_19 h_max-56 m-0 mb-4 border-0 d-flex justify-content-center align-items-center"
                      onClick={() => setDownload()}
                    >
                      {loader ? (
                        <CircularProgress size={24} />
                      ) : (
                        t("DownloadImage.Download")
                      )}
                    </button>
                  </Row>
                </Col>
              </Col>
            </Row>
          </Col>
        </Row>
      </Fade>
    </Modal>
  );
};

export default ProceedTemplate;
